import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class FirebaseDataShareService {
  // Blog id sharing
  private blogSource = new BehaviorSubject<string>("id");
  currentBlogid = this.blogSource.asObservable();

  // user id sharing 
  private UserSource = new BehaviorSubject<string>("id");
  currentUserid = this.UserSource.asObservable();

   // member id sharing
  private memberTypeSource = new BehaviorSubject<string>("non-member");
  currentMemberType = this.memberTypeSource.asObservable();

  constructor() {}

  changeBlog(currentBlogid: string) {
    this.blogSource.next(currentBlogid);
  }

  changeUser(currentUserId: string) {
    this.UserSource.next(currentUserId);
  }

  changeMemberType(currentMemberType: string){
    this.memberTypeSource.next(currentMemberType);
  }
}
